// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.ProductionControl.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.ProductionControl.Submodules.Palletized.Processes.Picking.Id,
    ],
  },
}));

export function picking() {
  return defineConfig({
    MantenerReservaPaleOrigenTraspasoMovilidad: {
      source: ConfigurationParameterSource.ERP,
      component: 'Ventas',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    ReplanificarCantidadPaleTraspasadoOReprocesado: {
      source: ConfigurationParameterSource.ERP,
      component: 'Ventas',
      useCaseCode: 'TRAUT900',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
  });
}
